import clsx from "clsx";
import { useCallback } from "react";
import * as defaultClasses from "../styles/mask.module.scss";
interface IProps {
  dismiss: () => void;
  delayedDismiss?: () => void;
  isActive: boolean;
  classes?: {
    [key: string]: string;
  };
}

const Mask = (props: IProps) => {
  const { dismiss, isActive, classes, delayedDismiss } = props;

  const className = isActive ? defaultClasses.root_active : defaultClasses.root;

  return (
    <button
      className={clsx(className, classes?.["root"], {
        [classes?.["root_active"]]: isActive,
      })}
      onClick={dismiss}
      onMouseOver={delayedDismiss}
    />
  );
};

export default Mask;
